'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTourContext } from 'onboarding-tours/hooks/tour';
import { useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UITour from 'ui-shepherd-react/tour/UITour';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import { Button } from 'foundations-components/transitional/components/Button';
import { H5 } from 'foundations-components/transitional/components/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TEST_VARIATION_TOUR_NAME = 'test-variation-approvals-tour';
const TEST_VARIATION_TOUR_STEPS = {
  STEP_1: 'approval-tour-variation-step-1',
  STEP_2: 'approval-tour-variation-step-2'
};
export const useTestVariationApprovalTour = () => {
  const {
    tour
  } = useTourContext(TourContext);
  const dispatch = useDispatch();
  const endTour = () => {
    dispatch({
      type: 'HIDE_APPROVALS_TEST_VARIATIONS_TOUR'
    });
    if (tour) {
      tour.deactivateTour(TEST_VARIATION_TOUR_NAME);
    }
  };
  const goToStepTwo = () => {
    if (tour && tour.getStep() === TEST_VARIATION_TOUR_STEPS.STEP_1) {
      tour.next(TEST_VARIATION_TOUR_STEPS.STEP_2);
    }
  };
  return {
    endTour,
    goToStepTwo
  };
};
const StartTour = () => {
  const tourContext = useContext(TourContext);
  const shouldStartTour = useSelector(state => {
    return state.testVariationTourStatus.get('shouldDisplayTour');
  });
  useEffect(() => {
    const {
      tour
    } = tourContext;
    const tourKey = tour.getTour();
    if (shouldStartTour && !!tourKey && tour.getStep() === 'not-started') {
      tour.start(TEST_VARIATION_TOUR_NAME);
    }
  }, [shouldStartTour, tourContext]);
};
export const TestVariationTourSecondStep = ({
  children
}) => {
  const {
    endTour
  } = useTestVariationApprovalTour();
  const targetRef = useRef(null);
  return /*#__PURE__*/_jsx(UITourStep, {
    stepKey: TEST_VARIATION_TOUR_STEPS.STEP_2,
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "testVariationsTour.header"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "testVariationsTour.step2.body"
      }),
      footer: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: endTour,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "testVariationsTour.step2.button"
        })
      })
    },
    pulser: true,
    targetRef: targetRef,
    children: /*#__PURE__*/_jsx("div", {
      ref: targetRef,
      children: children
    })
  });
};
export const TestVariationTours = ({
  name,
  children
}) => {
  const targetRef = useRef(null);
  return /*#__PURE__*/_jsxs(UITour, {
    tour: TEST_VARIATION_TOUR_NAME,
    activateOnMount: false,
    config: {
      steps: [TEST_VARIATION_TOUR_STEPS.STEP_1, TEST_VARIATION_TOUR_STEPS.STEP_2]
    },
    children: [/*#__PURE__*/_jsx(StartTour, {}), /*#__PURE__*/_jsx(UITourStep, {
      stepKey: TEST_VARIATION_TOUR_STEPS.STEP_1,
      content: {
        header: /*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "testVariationsTour.header"
          })
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "testVariationsTour.step1.body",
          options: {
            name
          }
        })
      },
      pulser: true,
      targetRef: targetRef,
      children: /*#__PURE__*/_jsx("div", {
        ref: targetRef,
        children: children
      })
    })]
  });
};